// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EUnderVotePolicy, isAcclaimedContest, } from "@sequentech/ui-core";
var UNDER_VOTE_ALERT = "errors.implicit.underVote";
var toCount = function (value, fallback) {
    var count = Number.parseInt(value !== null && value !== void 0 ? value : "", 10);
    return Number.isNaN(count) ? fallback : count;
};
// The contests the voter has to confirm before casting: those whose under-vote
// policy asks for it and that the ballot checker reports as under-voted.
export var getUnfilledContests = function (contests, decodedContests) {
    return contests.flatMap(function (contest) {
        var _a, _b, _c;
        if (isAcclaimedContest(contest) ||
            ((_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.under_vote_policy) !== EUnderVotePolicy.WARN_AND_CONFIRM_IN_REVIEW) {
            return [];
        }
        var decoded = decodedContests.find(function (item) { return item.contest_id === contest.id; });
        var underVote = decoded === null || decoded === void 0 ? void 0 : decoded.invalid_alerts.find(function (alert) { return alert.message === UNDER_VOTE_ALERT; });
        if (!decoded || decoded.is_explicit_invalid || !underVote) {
            return [];
        }
        return [
            {
                contest: contest,
                selected: toCount((_b = underVote.message_map) === null || _b === void 0 ? void 0 : _b.numSelected, 0),
                max: toCount((_c = underVote.message_map) === null || _c === void 0 ? void 0 : _c.max, contest.max_votes),
            },
        ];
    });
};
